import axios from 'axios'
import store from '../store'
import { common } from './common'

function decodeIssuedToken(token) {
    let [header, payload, signature] = token.split('.')

    //decode base64 payload after parse json format
    header = signature = payload = JSON.parse(atob(payload))
    return payload;
}

export const objectToFormdata = data => {
    let changeFormDataEntries = new FormData()

    for (var [key, value] of Object.entries(data)) {
      changeFormDataEntries.append(key, value)
      console.log(key, value);
    }

    return changeFormDataEntries;
};

export const instance = axios.create({
    baseURL: process.env.VUE_APP_API
})

instance.defaults.crossDomain = true;

//interceptor request
instance.interceptors.request.use(
    config => {
        config["headers"] = {
            Accept: "application/json, text/plain, */*",
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
//interceptor response
instance.interceptors.response.use(
    response => {
        return response;
    },
    async function(error) {

        const originalRequest = error.config;

        if (error.response.status !== 401 && error.response.status !== 403) {
            return new Promise.reject(error)
        }
        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            //request api common to refresh token
            const resToken = await common.get.autoRefreshToken({
                luidx: store.state.luidx
            })

            if (resToken.data.status === 200) {
                localStorage.setItem('accessToken', resToken.data.data.accessToken)
                
                let tokenInfo = decodeIssuedToken(resToken.data.data.accessToken)
                
                //An authentic token information is saved on vuex
                store.state.uuid = tokenInfo.sub
                store.state.luidx = Number(atob(tokenInfo.umc))
                store.state.cbidx = Number(atob(tokenInfo.cbc))
                store.state.accessToken = resToken.data.data.accessToken

                originalRequest.headers['Authorization'] = `Bearer ${resToken.data.data.accessToken}`
                const booleanCalledAxios = axios(originalRequest)

                return booleanCalledAxios
            } else {
                alert('인증정보 갱신에 실패했습니다. 다시 로그인 해주세요')
                store.dispatch('LOGOUT')
            }

        } else if (error.response.status === 403) {
            alert('잘못된 인증 요청, 좋지 않은 결과를 드려 죄송합니다. 다시 로그인 해주세요')
            store.dispatch('LOGOUT')
        }
    }
)
  
export default instance;


// WEBPACK FOOTER //
// ./src/api/http.js